<template>
  <EntityContainer
    containerId="cabinet-invitations"
  >
    <EntityNavBar
      :show-search="false"
      :show-add-button="false"
      :heading="$t('history')"
    />
    <BaseTabs
      v-model="personalSettings"
      small
      style="margin-bottom: 48px"
      class="mt-20"
      :tabs="[
        {
          text: $t('name.user_chronicles'),
          value: 'user',
          link: 'history.user.index',
        },
        {
          text: $t('name.counterparties_chronicles'),
          value: 'counterparties',
          link: 'history.counterparties.index',
        },
      ]"
    />
    <div class="w-full overflow-x-auto">
      <div class="pl-1 pr-1 pt-1 min-w-[1020px]">
        <slot />
      </div>
    </div>
  </EntityContainer>
</template>

<script>
import EntityNavBar from "~/components/Common/EntityNavBar.vue";
import EntityContainer from "~/components/Common/EntityContainer.vue";

export default {
  name: "BaseHistory",
  components: { EntityContainer, EntityNavBar },
  data() {
    return {
      personalSettings: "user"
    };
  },
  computed: {
    containerClass: function() {
      return this.personalSettings;
    }
  }
};
</script>
